import { Text } from '@lbcamden/lib-react';
import { formatDMY } from '@lbcamden/shared-utils';
import { FunctionComponent } from 'react';

import { useGetPersonDescription } from '~/client/hooks/storeHooks';
import { FullPcfraPerson } from '~/common/types/people';

import { getPersonAge } from '../helpers';
import { InfoContainer, InfoHeading } from '../ResidentCard.styled';

type Props = {
  person: FullPcfraPerson;
};

export const GeneralInfo: FunctionComponent<Props> = ({ person }) => {
  const { dateOfBirth } = person;

  const getPersonDescription = useGetPersonDescription();

  return (
    <InfoContainer>
      <InfoHeading>General information</InfoHeading>
      <Text>{getPersonDescription(person)}</Text>
      <Text>{`Date of birth: ${formatDMY(dateOfBirth)} (${getPersonAge(dateOfBirth)})`}</Text>
    </InfoContainer>
  );
};
